export const applyPwaScrollLock = (selector) => {
  const scrollContainers = document.querySelectorAll(selector);

  const preventRubberBand = (e) => {
    const el = e.currentTarget;

    if (el.scrollTop === 0) {
      el.scrollTop = 1;
    }

    else if (el.scrollHeight === el.scrollTop + el.offsetHeight) {
      el.scrollTop -= 1;
    }
  };

  scrollContainers.forEach((el) => {
    el.addEventListener("touchstart", preventRubberBand, { passive: true });
  });

  return () => {
    scrollContainers.forEach((el) => {
      el.removeEventListener("touchstart", preventRubberBand);
    });
  };
};
